import _ from 'lodash'
import { userPageFavoriteApi } from 'api'

const state = {
  favorites: []
}

const getters = {
  favorites: state => _.orderBy(state.favorites, 'pageNumber'),
  favoriteByPageNumber: state => pageNumber => {
    return state.favorites.find(up => up.pageNumber === pageNumber)
  }
}

const actions = {
  setFavorites ({commit}) {
    userPageFavoriteApi.getList().then(resp => {
      commit('setFavorites', resp.data)
    })
  },
  addFavorite ({commit}, pageNumber) {
    userPageFavoriteApi.add(pageNumber).then(resp => {
      commit('addFavorite', resp.data)
    })
  },
  removeFavorite ({commit}, pageNumber) {
    let fav = state.favorites.find(f => f.pageNumber === pageNumber)
    userPageFavoriteApi.delete(fav.id).then(resp => {
      commit('removeFavorite', pageNumber)
    })
  }
}
const mutations = {
  setFavorites (state, favorites) {
    state.favorites = favorites
  },
  addFavorite (state, favorite) {
    state.favorites.push(favorite)
  },
  removeFavorite (state, pageNumber) {
    state.favorites.splice(state.favorites.findIndex(up => up.pageNumber === pageNumber), 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userPageFavorite.js